import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "dialog-custom__header mb-4" }
const _hoisted_2 = { class: "dialog-custom__title mb-0" }
const _hoisted_3 = {
  key: 0,
  id: "dialog-plant-duplicate-spinner"
}
const _hoisted_4 = { class: "dialog-custom__content form-custom" }
const _hoisted_5 = { class: "p-field mb-4" }
const _hoisted_6 = { class: "d-block mb-2 p-field-label" }
const _hoisted_7 = { class: "mr-3" }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-field-label" }
const _hoisted_10 = { class: "dialog-custom__footer" }
const _hoisted_11 = {
  key: 1,
  class: "app-loader app-loader--contextual"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")
  const _component_NumberButtons = _resolveComponent("NumberButtons")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: true,
    showHeader: false,
    onHide: _ctx.doHideDialog,
    id: "plant-duplicate-dialog",
    visible: _ctx.isDialogVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDialogVisible = $event)),
    class: "dialog-custom dialog-plant-duplicate"
  }, {
    default: _withCtx(() => [
      _createVNode("header", _hoisted_1, [
        _createVNode("h1", _hoisted_2, _toDisplayString(_ctx.dialogTitle), 1)
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_3, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("plantDialogDuplicate.howManyCopies")), 1),
          _createVNode(_component_NumberButtons, {
            modelValue: _ctx.plantsCount,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.plantsCount = $event)),
            "disable-decrease": _ctx.plantsCount === 1
          }, null, 8, ["modelValue", "disable-decrease"])
        ]),
        _createVNode(_component_ElScrollbar, null, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("plantsList.duplicateDialog.inputLabel")), 1),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.plantsToCreate, (plant, idx) => {
                  return (_openBlock(), _createBlock(_component_InputText, {
                    type: "text",
                    ref: "nameInput",
                    modelValue: plant.name,
                    "onUpdate:modelValue": ($event: any) => (plant.name = $event),
                    key: 'plant_ ' + idx,
                    class: ["mt-2 mb-4 w-100", {
                                'input-error': !!plant.isInvalid,
                            }],
                    onInput: ($event: any) => (_ctx.handleNameChange(plant))
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "class"]))
                }), 128))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_Button, {
          onClick: _ctx.handleHideDialog,
          class: "p-button-text p-button-secondary text-uppercase mr-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          onClick: _ctx.doConfirm,
          disabled: _ctx.isConfirmDisabled,
          class: "p-button-rounded p-button--m"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Ok")), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_11, [
            _createVNode(_component_ProgressSpinner)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["onHide", "visible"]))
}